<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader bg-primary text-light">
        <div class="left">
            <a href="#" class="headerButton" data-bs-toggle="modal" data-bs-target="#sidebarPanel">
                <img src="@/assets/img/sample/avatar/avatar1.jpg" alt="image" class="imaged rounded w32">
                <span class="badge badge-danger">10</span>
            </a>
        </div>
        <div class="pageTitle">
            Billetera de Criptomonedas
        </div>
        <div class="right">
            <router-link :to="{ name: 'notifications' }" class="headerButton">
                <ion-icon class="icon" name="notifications-outline"></ion-icon>
                <span class="badge badge-danger">8</span>
            </router-link>
        </div>
    </div>
    <!-- * Encabezado de la aplicación -->


    <!-- Cápsula de la aplicación -->
    <div id="appCapsule">


        <!-- Billetera -->
        <div class="section full gradientSection">
            <div class="in">
                <h5 class="title mb-2">Saldo actual</h5>
                <h1 class="total">$ 2,562.50</h1>
                <h4 class="caption">
                    <span class="iconbox text-success">
                        <ion-icon name="trending-up-outline"></ion-icon>
                    </span>
                    0.053205 BTC
                </h4>
                <div class="wallet-inline-button mt-5">
                    <a href="#" class="item" data-bs-toggle="modal" data-bs-target="#depositActionSheet">
                        <div class="iconbox">
                            <ion-icon name="arrow-up-outline"></ion-icon>
                        </div>
                        <strong>Depósito</strong>
                    </a>
                    <a href="#" class="item" data-bs-toggle="modal" data-bs-target="#withdrawActionSheet">
                        <div class="iconbox">
                            <ion-icon name="arrow-down-outline"></ion-icon>
                        </div>
                        <strong>Retirada</strong>
                    </a>
                    <a href="#" class="item" data-bs-toggle="modal" data-bs-target="#sendActionSheet">
                        <div class="iconbox">
                            <ion-icon name="arrow-forward-outline"></ion-icon>
                        </div>
                        <strong>Enviar</strong>
                    </a>
                    <a href="crypto-exchange.php" class="item">
                        <div class="iconbox">
                            <ion-icon name="swap-vertical-outline"></ion-icon>
                        </div>
                        <strong>Intercambio</strong>
                    </a>
                </div>
            </div>
        </div>
        <!-- * Billetera -->


        <!-- Hoja de acción de depósito -->
        <div class="modal fade action-sheet" id="depositActionSheet" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Depósito</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <form>
                                <div class="form-group basic mb-2">
                                    <div class="input-wrapper">
                                        <label class="label" for="account2">Seleccionar cuenta</label>
                                        <select class="form-control custom-select" id="account2">
                                            <option value="0">Ahorros (*** 5019)</option>
                                            <option value="1">Inversión (*** 6212)</option>
                                            <option value="2">Hipoteca (*** 5021)</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label" for="depositAmount">Ingrese la cantidad</label>
                                        <div class="exchange-group small">
                                            <div class="input-col">
                                                <input type="text" class="form-control form-control-lg pe-0"
                                                    id="depositAmount" placeholder="0" value="380" maxlength="14">
                                            </div>
                                            <div class="select-col">
                                                <select class="form-select form-select-lg currency">
                                                    <option value="USD" selected>USD</option>
                                                    <option value="EUR">EUR</option>
                                                    <option value="AUD">AUD</option>
                                                    <option value="CAD">CAD</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2">
                                    <button type="button" class="btn btn-primary btn-lg btn-block"
                                        data-bs-dismiss="modal">Depositar</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- * Hoja de acción de depósito-->

        <!-- Hoja de acción de retiro -->
        <div class="modal fade action-sheet" id="withdrawActionSheet" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Retirada</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <form>
                                <div class="form-group basic mb-2">
                                    <div class="input-wrapper">
                                        <label class="label" for="account3">Seleccionar cuenta</label>
                                        <select class="form-control custom-select" id="account3">
                                            <option value="0">Ahorros (*** 5019)</option>
                                            <option value="1">Inversión (*** 6212)</option>
                                            <option value="2">Hipoteca (*** 5021)</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group basic mb-2">
                                    <div class="input-wrapper">
                                        <label class="label" for="iban1">IBAN</label>
                                        <input type="email" class="form-control" id="iban1"
                                            placeholder="Ingrese su IBAN">
                                        <i class="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label" for="withdrawAmount">Ingrese la cantidad</label>
                                        <div class="exchange-group small">
                                            <div class="input-col">
                                                <input type="text" class="form-control form-control-lg pe-0"
                                                    id="withdrawAmount" placeholder="0" value="380" maxlength="14">
                                            </div>
                                            <div class="select-col">
                                                <select class="form-select form-select-lg currency">
                                                    <option value="USD" selected>USD</option>
                                                    <option value="EUR">EUR</option>
                                                    <option value="AUD">AUD</option>
                                                    <option value="CAD">CAD</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2">
                                    <button type="button" class="btn btn-primary btn-lg btn-block"
                                        data-bs-dismiss="modal">Retirar</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- * Hoja de acción de retiro-->

        <!-- Hoja de acción de envío -->
        <div class="modal fade action-sheet" id="sendActionSheet" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Enviar</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <form>

                                <div class="form-group basic mb-2">
                                    <div class="input-wrapper">
                                        <label class="label" for="walletaddress">Dirección de la billetera</label>
                                        <input type="email" class="form-control" id="walletaddress"
                                            placeholder="Ingrese una dirección de billetera">
                                        <i class="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label" for="sendAmount">Ingrese la cantidad</label>
                                        <div class="exchange-group small">
                                            <div class="input-col">
                                                <input type="text" class="form-control form-control-lg pe-0"
                                                    id="sendAmount" placeholder="0" value="380" maxlength="14">
                                            </div>
                                            <div class="select-col">
                                                <select class="form-select form-select-lg currency">
                                                    <option value="BTC" selected>BTC</option>
                                                    <option value="ETH">ETH</option>
                                                    <option value="ADA">ADA</option>
                                                    <option value="USDT">USDT</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2">
                                    <button type="button" class="btn btn-primary btn-lg btn-block"
                                        data-bs-dismiss="modal">Enviar</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- * Hoja de acción de envío-->

        <div class="section mt-4">
            <div class="section-heading">
                <h2 class="title">Redes Disponibles ({{ chainlist.length }})</h2>
                <a href="/chainlist" class="link">Ver todo</a>
            </div>
            <div class="card">
                <ul class="listview flush transparent no-line image-listview detailed-list mt-1 mb-1">
                    <!-- ítem -->
                    <!-- <li>
                        <div class="item">
                            <div class="icon-box text-success">
                                <img src="https://icons.llamao.fi/icons/chains/rsz_canto.jpg" />
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Bitcoin</strong>
                                    <div class="text-small text-secondary">0.053201 BTC</div>
                                </div>
                                <div class="text-end">
                                    <strong>$5,503.30</strong>
                                    <div class="text-small">
                                        <span class="badge badge-success">
                                            <ion-icon name="arrow-up-outline"></ion-icon>
                                            2.59%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li> -->
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li v-for="(chain, c) in chainlist" v-bind:key="'index-chain-'+c">
                        <div :class="'item' + ((chain.rpc.length == 0) ? ' bg-danger' : '')">
                            <div class="icon-box text-success">
                                <img height="26" :src="chain.icon == undefined ? 'https://chainlist.org/unknown-logo.png' : 'https://icons.llamao.fi/icons/chains/rsz_' + chain.icon + '.jpg'" />
                            </div>
                            <div class="in">
                                <div>
                                    <strong>{{ chain.name }} ({{ chain.chain }}) - {{ chain.nativeCurrency.name }} [{{ chain.nativeCurrency.symbol }}]</strong>
                                    <div class="text-small text-secondary">
                                        chainId: {{ chain.chainId }} - networkId: {{ chain.networkId }}
                                        <!-- Unidad minima -->
                                         <!-- {{ (1 / (10 ** chain.nativeCurrency.decimals)).toFixed(chain.nativeCurrency.decimals) }} {{ chain.nativeCurrency.symbol }} -->
                                    </div>
                                    <p>
                                        <!-- faucets: {{ chain.faucets }} -->
                                        faucets: {{ chain.faucets.length }}
                                    </p>
                                    <p>rpc: {{ chain.rpc.length }}</p>
                                    <!-- <p>explorers: {{ chain.explorers.length }}</p> -->
                                    <!-- <p>Rpcs: {{ chain.rpc }}</p>
                                    <p>explorers: {{ chain.explorers }}</p> -->
                                </div>
                                <div class="text-end">
                                    <strong>{{ chain.slip44 }}</strong>
                                    <div class="text-small">
                                        <a class="badge badge-primary" :href="chain.infoURL" target="_blank">
                                            infoURL
                                        </a>
                                        <br />
                                        <span class="badge badge-secondary" v-for="(feature, f) in chain.features" v-bind:key="'feature-'+c+f">
                                            {{ feature.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- * ítem -->
                </ul>
            </div>
        </div>

        <!-- Portafolio -->
        <div class="section mt-4">
            <div class="section-heading">
                <h2 class="title">Mi portafolio</h2>
                <a href="crypto-portfolio.php" class="link">Ver todo</a>
            </div>
            <div class="card">
                <ul class="listview flush transparent no-line image-listview detailed-list mt-1 mb-1">
                    <!-- ítem -->
                    <li>
                        <div class="item">
                            <div class="icon-box text-success">
                                <ion-icon name="trending-up-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Bitcoin</strong>
                                    <div class="text-small text-secondary">0.053201 BTC</div>
                                </div>
                                <div class="text-end">
                                    <strong>$5,503.30</strong>
                                    <div class="text-small">
                                        <span class="badge badge-success">
                                            <ion-icon name="arrow-up-outline"></ion-icon>
                                            2.59%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li>
                        <div class="item">
                            <div class="icon-box text-success">
                                <ion-icon name="trending-up-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Ethereum</strong>
                                    <div class="text-small text-secondary">45.5469 ETH</div>
                                </div>
                                <div class="text-end">
                                    <strong>$1,246.47</strong>
                                    <div class="text-small">
                                        <span class="badge badge-success">
                                            <ion-icon name="arrow-up-outline"></ion-icon>
                                            2.59%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li>
                        <div class="item">
                            <div class="icon-box text-danger">
                                <ion-icon name="trending-down-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Cardano</strong>
                                    <div class="text-small text-secondary">251.48 ADA</div>
                                </div>
                                <div class="text-end">
                                    <strong>$316.50</strong>
                                    <div class="text-small">
                                        <span class="badge badge-danger">
                                            <ion-icon name="arrow-down-outline"></ion-icon>
                                            2.59%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li>
                        <div class="item">
                            <div class="icon-box text-success">
                                <ion-icon name="trending-up-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Tether</strong>
                                    <div class="text-small text-secondary">45.5469 USDT</div>
                                </div>
                                <div class="text-end">
                                    <strong>$45.54</strong>
                                    <div class="text-small">
                                        <span class="badge badge-success">
                                            <ion-icon name="arrow-up-outline"></ion-icon>
                                            2.59%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- * ítem -->
                </ul>
            </div>
        </div>
        <!-- Portafolio -->


        <!-- Lista de seguimiento -->
        <div class="section-heading padding mt-4">
            <h2 class="title">Lista de seguimiento</h2>
            <a href="#" class="link">Ver todo</a>
        </div>
        <!-- carrusel  -->
        <div class="carousel-multiple splide">
            <div class="splide__track">
                <ul class="splide__list">
                    <!-- ítem -->
                    <li class="splide__slide">
                        <div class="card coinbox">
                            <div class="card-body pb-0">
                                <a href="#" class="fixed-button" data-bs-toggle="modal"
                                    data-bs-target="#actionSheetWatchlist">
                                    <ion-icon name="ellipsis-vertical"></ion-icon>
                                </a>
                                <h4>BTC/USD</h4>
                                <div class="text">$38,509.44</div>
                                <div class="change">
                                    <span class="badge badge-success">
                                        <ion-icon name="arrow-up-outline"></ion-icon>
                                        6.78%
                                    </span>
                                </div>
                            </div>
                            <div class="chart chart-sparkline-success-1"></div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li class="splide__slide">
                        <div class="card coinbox">
                            <div class="card-body pb-0">
                                <a href="#" class="fixed-button" data-bs-toggle="modal"
                                    data-bs-target="#actionSheetWatchlist">
                                    <ion-icon name="ellipsis-vertical"></ion-icon>
                                </a>
                                <h4>ETH/USD</h4>
                                <div class="text">$1,462.61</div>
                                <div class="change">
                                    <span class="badge badge-danger">
                                        <ion-icon name="arrow-down-outline"></ion-icon>
                                        2.54%
                                    </span>
                                </div>
                            </div>
                            <div class="chart chart-sparkline-danger-1"></div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li class="splide__slide">
                        <div class="card coinbox">
                            <div class="card-body pb-0">
                                <a href="#" class="fixed-button" data-bs-toggle="modal"
                                    data-bs-target="#actionSheetWatchlist">
                                    <ion-icon name="ellipsis-vertical"></ion-icon>
                                </a>
                                <h4>USDT/USD</h4>
                                <div class="text">$0.99995</div>
                                <div class="change">
                                    <span class="badge badge-success">
                                        <ion-icon name="arrow-up-outline"></ion-icon>
                                        0.05%
                                    </span>
                                </div>
                            </div>
                            <div class="chart chart-sparkline-success-2"></div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li class="splide__slide">
                        <div class="card coinbox">
                            <div class="card-body pb-0">
                                <a href="#" class="fixed-button" data-bs-toggle="modal"
                                    data-bs-target="#actionSheetWatchlist">
                                    <ion-icon name="ellipsis-vertical"></ion-icon>
                                </a>
                                <h4>DOGE/USD</h4>
                                <div class="text">$0.198410</div>
                                <div class="change">
                                    <span class="badge badge-success">
                                        <ion-icon name="arrow-up-outline"></ion-icon>
                                        1.73%
                                    </span>
                                </div>
                            </div>
                            <div class="chart chart-sparkline-success-1"></div>
                        </div>
                    </li>
                    <!-- * ítem -->
                    <!-- ítem -->
                    <li class="splide__slide">
                        <div class="card coinbox">
                            <div class="card-body pb-0">
                                <a href="#" class="fixed-button" data-bs-toggle="modal"
                                    data-bs-target="#actionSheetWatchlist">
                                    <ion-icon name="ellipsis-vertical"></ion-icon>
                                </a>
                                <h4>ADA/USD</h4>
                                <div class="text">$1.271472</div>
                                <div class="change">
                                    <span class="badge badge-danger">
                                        <ion-icon name="arrow-down-outline"></ion-icon>
                                        0.69%
                                    </span>
                                </div>
                            </div>
                            <div class="chart chart-sparkline-danger-2"></div>
                        </div>
                    </li>
                    <!-- * ítem -->
                </ul>
            </div>
        </div>
        <!-- * carrusel  -->
        <!-- Lista de seguimiento -->

        <!-- Hoja de acción de la lista de seguimiento -->
        <div class="modal fade action-sheet" id="actionSheetWatchlist" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">BTC/USD</h5>
                        <h3 class="text-center mb-05 fontsize-headingLarge text-success">$38,509.44</h3>
                        <div class="text-muted text-center mb-1 fontsize-caption">Añadido hace 28 días</div>
                    </div>

                    <div class="modal-body">
                        <ul class="action-button-list">
                            <li>
                                <a href="#" class="btn btn-list" data-bs-dismiss="modal">
                                    <span>Comprar</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="btn btn-list" data-bs-dismiss="modal">
                                    <span>Vender</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="btn btn-list" data-bs-dismiss="modal">
                                    <span>Eliminar de la lista</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="btn btn-list" data-bs-dismiss="modal">
                                    <span>Ocultar de la lista</span>
                                </a>
                            </li>
                            <li class="action-divider"></li>
                            <li>
                                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                    <span>Cerrar</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- * Hoja de acción de la lista de seguimiento -->


        <!-- Transacciones -->
        <div class="section mt-4">
            <div class="section-heading">
                <h2 class="title">Transacciones</h2>
                <a href="crypto-transactions.php" class="link">Ver todas</a>
            </div>
            <div class="card">
                <ul class="listview flush transparent no-line image-listview detailed-list mt-1 mb-1">
                    <!-- item -->
                    <li>
                        <a href="#" class="item">
                            <div class="icon-box bg-success">
                                <ion-icon name="arrow-up-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Bitcoin</strong>
                                    <div class="text-small text-secondary">Vender</div>
                                </div>
                                <div class="text-end">
                                    <strong>$855,24</strong>
                                    <div class="text-small">
                                        Hoy 11:38 AM
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <!-- * item -->
                    <!-- item -->
                    <li>
                        <a href="#" class="item">
                            <div class="icon-box bg-warning">
                                <ion-icon name="arrow-down-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Etherium</strong>
                                    <div class="text-small text-secondary">Comprar</div>
                                </div>
                                <div class="text-end">
                                    <strong>$40,68</strong>
                                    <div class="text-small">
                                        8 de marzo de 2021
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <!-- * item -->
                    <!-- item -->
                    <li>
                        <a href="#" class="item">
                            <div class="icon-box">
                                <img src="@/assets/img/sample/avatar/avatar4.jpg" alt="image" class="imaged rounded w36">
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Bitcoin</strong>
                                    <div class="text-small text-secondary">Enviar</div>
                                </div>
                                <div class="text-end">
                                    <strong>$100,00</strong>
                                    <div class="text-small">
                                        4 de marzo de 2021
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <!-- * item -->
                    <!-- item -->
                    <li>
                        <a href="#" class="item">
                            <div class="icon-box bg-secondary">
                                <ion-icon name="swap-vertical-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <strong>Tether</strong>
                                    <div class="text-small text-secondary">Intercambiar</div>
                                </div>
                                <div class="text-end">
                                    <strong>$2.405,48</strong>
                                    <div class="text-small">
                                        24 de febrero de 2021
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <!-- * item -->
                </ul>
            </div>
        </div>
        <!-- Transacciones -->


        <!-- Deslizador -->
        <div class="section mt-4 full">
            <div class="carousel-single splide">
                <div class="splide__track">
                    <ul class="splide__list">

                        <li class="splide__slide">
                            <div class="card card-with-icon">
                                <div class="card-body pt-3 pb-3 text-center">
                                    <div class="card-icon bg-success mb-2">
                                        <ion-icon name="link"></ion-icon>
                                    </div>
                                    <h3 class="card-titlde mb-1">Recomienda a un amigo</h3>

                                    <p>¡Invita a tus amigos y gana premios!</p>
                                    <div class="row">
                                        <div class="col">
                                            <a href="#" class="btn btn-secondary">
                                                <ion-icon name="copy-outline"></ion-icon>
                                                Invitar ahora
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="splide__slide">
                            <div class="card card-with-icon">
                                <div class="card-body pt-3 pb-3 text-center">
                                    <div class="card-icon mb-2">
                                        <ion-icon name="chatbox-ellipses"></ion-icon>
                                    </div>
                                    <h3 class="card-titlde mb-1">Únete a nuestro chat grupal</h3>

                                    <p>¡Hablemos sobre el mercado y las estrategias!</p>
                                    <div class="row">
                                        <div class="col">
                                            <a href="component-messages.php" class="btn btn-block btn-primary">
                                                Unirse ahora
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a href="component-messages.php" class="btn btn-block btn-secondary">
                                                Ver grupos
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="splide__slide">
                            <div class="card card-with-icon">
                                <div class="card-body pt-3 pb-3 text-center">
                                    <div class="card-icon bg-secondary mb-2">
                                        <ion-icon name="share-social-outline"></ion-icon>
                                    </div>
                                    <h3 class="card-titlde mb-1">Síguenos</h3>

                                    <p>¡Síguenos en las redes sociales!</p>
                                    <div class="row">
                                        <div class="col">
                                            <a href="#" class="btn btn-block btn-facebook">
                                                <ion-icon name="logo-facebook"></ion-icon>
                                                Facebook
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a href="#" class="btn btn-block btn-twitter">
                                                <ion-icon name="logo-twitter"></ion-icon>
                                                Twitter
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
        <!-- * Deslizador -->


        <!-- Noticias -->
        <div class="section full mt-4 mb-3">
            <div class="section-heading padding">
                <h2 class="title">Últimas noticias</h2>
                <a href="app-blog.php" class="link">Ver todo</a>
            </div>

            <!-- carrusel multiple -->
            <div class="carousel-multiple splide">
                <div class="splide__track">
                    <ul class="splide__list">

                        <li class="splide__slide">
                            <a href="app-blog-post.php">
                                <div class="blog-card">
                                    <img src="@/assets/img/sample/photo/1.jpg" alt="image" class="imaged w-100">
                                    <div class="text">
                                        <h4 class="title">¿Cuál será el valor de bitcoin en el próximo...</h4>
                                    </div>
                                </div>
                            </a>
                        </li>

                        <li class="splide__slide">
                            <a href="app-blog-post.php">
                                <div class="blog-card">
                                    <img src="@/assets/img/sample/photo/2.jpg" alt="image" class="imaged w-100">
                                    <div class="text">
                                        <h4 class="title">Reglas que necesitas saber en los negocios</h4>
                                    </div>
                                </div>
                            </a>
                        </li>

                        <li class="splide__slide">
                            <a href="app-blog-post.php">
                                <div class="blog-card">
                                    <img src="@/assets/img/sample/photo/3.jpg" alt="image" class="imaged w-100">
                                    <div class="text">
                                        <h4 class="title">10 maneras fáciles de ahorrar dinero</h4>
                                    </div>
                                </div>
                            </a>
                        </li>

                        <li class="splide__slide">
                            <a href="app-blog-post.php">
                                <div class="blog-card">
                                    <img src="@/assets/img/sample/photo/4.jpg" alt="image" class="imaged w-100">
                                    <div class="text">
                                        <h4 class="title">Sigue la agenda financiera con...</h4>
                                    </div>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
            <!-- * carrusel multiple -->

        </div>
        <!-- * Noticias -->


        <!-- pie de página de la aplicación -->
        <div class="appFooter">
            <div class="footer-title">
                Copyright © SombreroWallet 2021. Todos los derechos reservados.
            </div>
            Plantilla móvil basada en Bootstrap 5.
        </div>
        <!-- * pie de página de la aplicación -->

    </div>
    <!-- * App Capsule -->

    <default-sidebar />

    <default-button-menu />
</template>

<script>
import ApexCharts from 'apexcharts'
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            chainlist: [],
        };
    },
    async mounted() {
        this.$root.loadBackButtom();
        await this.loadChainlist()
        this.loadCarousel()
        this.loadSparks()
    },
    methods: {
        ...mapActions(['getChainlist']),
        async loadChainlist() {
            const chainlist = await this.getChainlist();
            console.log('chainlist', chainlist)
            this.chainlist = chainlist;
        },
        loadSparks() {
            var sparklineAreaExampleSuccess1 = {
                series: [{
                    data: [555, 1222, 777, 888, 555, 888, 999, 1222]
                }],
                chart: {
                    type: 'area',
                    width: '100%',
                    height: 70,
                    sparkline: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 2,
                },
                colors: ['#1DCC70'],
                tooltip: {
                    enabled: false
                }
            };
            var sparklineAreaExampleSuccess2 = {
                series: [{
                    data: [55, 66, 55, 77, 66, 180, 290, 333]
                }],
                chart: {
                    type: 'area',
                    width: '100%',
                    height: 70,
                    sparkline: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 2,
                },
                colors: ['#1DCC70'],
                tooltip: {
                    enabled: false
                }
            };
            var sparklineAreaExampleDanger1 = {
                series: [{
                    data: [2222, 1666, 1444, 1777, 1333, 1111, 777, 666]
                }],
                chart: {
                    type: 'area',
                    width: '100%',
                    height: 70,
                    sparkline: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 2,
                },
                colors: ['#FF396F'],
                tooltip: {
                    enabled: false
                }
            };
            var sparklineAreaExampleDanger2 = {
                series: [{
                    data: [1200, 1444, 2900, 505, 531, 1900, 555, 75]
                }],
                chart: {
                    type: 'area',
                    width: '100%',
                    height: 70,
                    sparkline: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 2,
                },
                colors: ['#FF396F'],
                tooltip: {
                    enabled: false
                }
            };

            document.querySelectorAll('.chart-sparkline-success-1').forEach(chart => new ApexCharts(chart, sparklineAreaExampleSuccess1).render());
            document.querySelectorAll('.chart-sparkline-success-2').forEach(chart => new ApexCharts(chart, sparklineAreaExampleSuccess2).render());
            document.querySelectorAll('.chart-sparkline-danger-1').forEach(chart => new ApexCharts(chart, sparklineAreaExampleDanger1).render());
            document.querySelectorAll('.chart-sparkline-danger-2').forEach(chart => new ApexCharts(chart, sparklineAreaExampleDanger2).render());
        },
        loadCarousel() {
            // eslint-disable-next-line
            document.querySelectorAll('.carousel-multiple').forEach(carousel => new Splide(carousel, {
                perPage: 4,
                rewind: true,
                type: "loop",
                gap: 16,
                padding: 16,
                arrows: false,
                pagination: false,
                breakpoints: {
                    768: {
                        perPage: 2
                    },
                    991: {
                        perPage: 3
                    }
                }
            }).mount());
            
            // eslint-disable-next-line
            document.querySelectorAll('.carousel-single').forEach(carousel => new Splide(carousel, {
                perPage: 3,
                rewind: true,
                type: "loop",
                gap: 16,
                padding: 16,
                arrows: false,
                pagination: false,
                breakpoints: {
                    768: {
                        perPage: 1
                    },
                    991: {
                        perPage: 2
                    }
                }
            }).mount());
        }
    }
}
</script>